/**
 * rokhu-article.js
 * Reading progress bar + auto table of contents for the Rokhu editorial article layout.
 */
(function () {
  'use strict';

  /* ── Reading progress ── */
  var progressBar = document.getElementById('rokhu-reading-progress-bar');
  var articleBody = document.getElementById('rokhu-article-body');

  function updateProgress() {
    if (!progressBar || !articleBody) return;
    var rect = articleBody.getBoundingClientRect();
    var bodyHeight = articleBody.offsetHeight;
    var scrolled = Math.max(0, -rect.top);
    var pct = Math.min(100, (scrolled / bodyHeight) * 100);
    progressBar.style.width = pct + '%';
  }

  /* ── Table of contents ── */
  var tocList = document.getElementById('rokhu-article-toc');

  function buildTOC() {
    if (!tocList || !articleBody) return;
    var headings = articleBody.querySelectorAll('h2[id], h3[id]');
    if (!headings.length) {
      var tocWrap = tocList.closest('.rokhu-sidebar-toc');
      if (tocWrap) tocWrap.style.display = 'none';
      return;
    }
    var fragment = document.createDocumentFragment();
    headings.forEach(function (h) {
      var li = document.createElement('li');
      li.className = h.tagName === 'H3' ? 'rokhu-toc-sub' : '';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(h.id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          /* offset for sticky header */
          var stickyOffset = 80;
          setTimeout(function () {
            window.scrollBy(0, -stickyOffset);
          }, 400);
        }
      });
      li.appendChild(a);
      fragment.appendChild(li);
    });
    tocList.appendChild(fragment);
  }

  /* ── Active TOC link on scroll ── */
  function activateTOC() {
    if (!tocList || !articleBody) return;
    var links = tocList.querySelectorAll('a');
    if (!links.length) return;
    var ids = Array.from(links).map(function (a) { return a.getAttribute('href').slice(1); });
    var current = '';
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (el.getBoundingClientRect().top <= 120) {
        current = id;
      }
    });
    links.forEach(function (a) {
      var isActive = a.getAttribute('href') === '#' + current;
      a.classList.toggle('rokhu-toc-active', isActive);
    });
  }

  /* ── Init ── */
  function init() {
    buildTOC();
    updateProgress();
    activateTOC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        updateProgress();
        activateTOC();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();
